module.exports = __webpack_public_path__ + "img/Home22.d576187d.jpg";